import { parseCookies } from 'nookies'
import getConfig from 'next/config'

const {
  publicRuntimeConfig: { RELEASEID },
} = getConfig()

const commonDataDogContext = {
  name: 'extractGaSessionId',
  service: 'fairprice-website',
  version: RELEASEID,
}

// Cache the Datadog RUM instance between calls
let cachedDatadogRum = null
function getDatadogRum() {
  if (typeof window === 'undefined') {
    return null
  }
  if (cachedDatadogRum) {
    return cachedDatadogRum
  }
  try {
    cachedDatadogRum = require('@datadog/browser-rum-slim').datadogRum
    return cachedDatadogRum
  } catch (e) {
    return null
  }
}

function ddRumAction(name, context) {
  if (typeof window === 'undefined') {
    return
  }
  const rum = getDatadogRum()
  rum?.addAction({
    ...commonDataDogContext,
    name,
    context,
  })
}

function ddRumError(name, context) {
  if (typeof window === 'undefined') {
    return
  }
  const rum = getDatadogRum()
  rum?.addError({
    ...commonDataDogContext,
    name,
    context,
  })
}

function extractGaSessionId(measurementId) {
  const cookies = parseCookies()
  const sessionCookieName = `_ga_${measurementId}`
  const sessionCookie = cookies[sessionCookieName]
  let gaSessionId = null

  ddRumAction('extractGaSessionId_invoked', {
    sessionCookieName,
    sessionCookie,
    cookies,
  })

  if (!sessionCookie) {
    ddRumError('extractGaSessionId_invoked_error', {
      sessionCookieName,
      sessionCookie,
      cookies,
    })
    return null
  }

  // Check for new `$` format, GS2.1.s1746602632$o1$g1$t1746603143$j0$l0$h0 expected value 1746602632
  if (sessionCookie.includes('$')) {
    const match = sessionCookie.match(/\.s(\d+)\$/)
    if (match) {
      gaSessionId = match[1]
      ddRumAction('extractGaSessionId_match', {
        sessionCookieName,
        sessionCookie,
        gaSessionId,
        cookies,
      })
      return gaSessionId
    }
    ddRumError('extractGaSessionId_not_match', {
      sessionCookieName,
      sessionCookie,
      gaSessionId: null,
      cookies,
    })
  }

  // Fallback: old `.`-separated format, GS1.1.1744101655.71.1.1744101680.0.0.0 expected value 1744101655
  const parts = sessionCookie.split('.')
  gaSessionId = parts.length >= 5 ? parts[2] : null
  ddRumAction('extractGaSessionId_fallback_old', {
    sessionCookieName,
    sessionCookie,
    gaSessionId,
    cookies,
  })
  return gaSessionId
}

export { extractGaSessionId, getDatadogRum }
